import { EndpointSetting } from "@/constants/app/type";
import { EsimState } from "../types";

export const callbackProductContentPublicList: EndpointSetting["caller"] = (
  state: EsimState,
  action,
) => {
  const payload = action.payload ?? {};
  const contents = Array.isArray(payload.contents) ? payload.contents : [];
  state.product_content_public_list.data.contents = contents;
  state.product_content_public_list.data.totalRecords = payload.pagination?.total ?? contents.length;
};
